import React from 'react';
export const LegendRiskModerateIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11 3L19.6603 18H2.33975L11 3Z" fill="#F68511" />
  </svg>
);
